import {ConfirmationModalComponent} from '../confirmation/confirmation-modal.component';
import {Floor} from './floor.model';
import {FloorService} from './floor.service';
import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {UIRouter} from '@uirouter/angular';
import {DatatableViewComponent, SortOption} from '@ngx-ivengi/crud';
import {RoutePrefix} from '../shared/route-prefix';

@Component({
  selector: 'app-floor-datatable',
  templateUrl: './floor-datatable.component.html'
})
export class FloorDatatableComponent extends DatatableViewComponent<Floor> implements OnDestroy, OnInit {

  @ViewChild(ConfirmationModalComponent)
  public confirmationModal: ConfirmationModalComponent;

  @Input() public routePrefix: RoutePrefix | RoutePrefix[];

  constructor(
    protected floorService: FloorService,
    private router: UIRouter
  ) {
    super(floorService);

    this.requestParams.addSortParam({
      key: 'number',
      value: SortOption.Ascending
    });

  }

  public deleteItem(item) {
    this.confirmationModal.show(item);
  }

  public onDeleteConfirmation(event) {
    if(event.confirmed === true) {
      this.floorService.delete(event.data).subscribe(() => {
        this.router.stateService.go(this.router.stateService.$current.name, this.router.stateService.params, {reload: true});
      });
    }
  }

  public ngOnDestroy(): void {
    this.floorService.clearRoutePrefix();
  }

  ngOnInit(): void {
    if(this.routePrefix) {
      const prefixParts = (this.routePrefix instanceof Array) ? this.routePrefix : [this.routePrefix];

      const prefix  = prefixParts.map((item) => {
        return `${item.entity}/${item.entityId}`;
      });

      this.floorService.setRoutePrefix(prefix.join('/').toLowerCase());
    }

    this.fetchData();
  }

  public onRowClick(event) {
    if (event.type !== 'dblclick' || typeof event.column === 'undefined' || event.column.prop === 'menu' || typeof event.row === 'undefined') {
      return;
    }
    this.router.stateService.go('building.edit.floor.edit', { floorId: event.row.id }, { reload: true });
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/floor/floor-datatable.component.ts